export default __webpack_public_path__ + "static/media/about2_t.62825793.png";